(function () {
    'use strict';

    angular
        .module('elogbooks.user.reports')
        .controller('UserReportsSpSummaryDetailsController', UserReportsSpSummaryDetailsController);

    UserReportsSpSummaryDetailsController.$inject = ['$state', '$stateParams', 'siteGroupsCollection', 'serviceProviderGroupsCollection', 'moment', 'reportTotalsService',
        '$q', 'showPercentagesService', 'locationCollectionResponse', 'siteCollectionResponse', 'coreClientsCollectionResponse', 'apiClient', '$translate', 'modulesService', 'rootResourceResponse'];

    function UserReportsSpSummaryDetailsController($state, $stateParams, siteGroupsCollection, serviceProviderGroupsCollection, moment, reportTotalsService,
            $q, showPercentagesService, locationCollectionResponse, siteCollectionResponse, coreClientsCollectionResponse, apiClient, $translate, modulesService, rootResourceResponse) {

        var vm = this;

        // Initialize service providers data and loading state
        vm.serviceProvidersResponse = null;
        vm.serviceProviders = [];
        vm.serviceProvidersLoading = true;

        vm.siteGroupsCollection = siteGroupsCollection;
        vm.serviceProviderGroupsCollection = serviceProviderGroupsCollection;
        vm.siteGroups = siteGroupsCollection.sitegroups;
        vm.stateParams = $stateParams;
        vm.isTaskModuleEnabled = modulesService.isEnabled('tasks_module') || rootResourceResponse.plannedJobsExist;
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
        vm.showPercentages = showPercentagesService.getShowPercentageState();
        vm.exportParams = {showPercentages: vm.showPercentages};

        vm.search = search;
        vm.saveParams = saveParams;
        vm.order = orderAction;
        vm.updateShowPercentages = updateShowPercentages;
        vm.getTotalForReportType = getTotalForReportType;
        vm.isLoadingReportType = isLoadingReportType;
        vm.loadServiceProviders = loadServiceProviders;

        // Initialize individual totals and loading states
        vm.individualTotals = {};
        vm.individualLoadingStates = {};

        // Load service providers data immediately
        loadServiceProviders();

        vm.siteSelect = {
            response : siteCollectionResponse,
            link : siteCollectionResponse && siteCollectionResponse.count > 0 ? siteCollectionResponse.getLink('self') : null,
            responseKeyPath: 'sites',
            itemValuePath: 'id',
            itemTitlePath: 'name',
        };

        vm.siteGroupSelect = {
            response: siteGroupsCollection,
            responseKeyPath: 'sitegroups'
        };

        vm.serviceProviderGroupSelect = {
            response: serviceProviderGroupsCollection,
            responseKeyPath: 'groups'
        };

        vm.locationSelect = {
            response : locationCollectionResponse,
            link : locationCollectionResponse && locationCollectionResponse.count > 0 ? locationCollectionResponse.getLink('self') : null,
            responseKeyPath: 'locations',
            itemValuePath: 'id',
            itemTitlePath: 'name',
            disabled: true,
            selected: null,
        };

        var statusOptions = [
            {title: $translate.instant('ALL'), value: 'all'},
            {title: $translate.instant('STATUS_ACTIVE'), value: 'active'},
            {title: $translate.instant('STATUS_INACTIVE'), value: 'inactive_or_training'}
        ];

        vm.criteria = {
            name: { type: 'text', title: 'NAME', value: $stateParams.name},
            hours: { type: 'number', title: 'AWAITING_PAPERWORK_SINCE', value: parseInt($stateParams.hours,10)  , min: 1, max: 500, step: 1},
            siteRegionName: { type: 'text', title: 'REGION', value: $stateParams.siteRegionName },
            site: { type: 'jsonselectwidget', title: 'SITE', value: JSON.parse($stateParams.site), options: vm.siteSelect },
            location: { type: 'jsonselectwidget', title: 'LOCATION', value: JSON.parse($stateParams.location), options: vm.locationSelect},
            siteGroupName: { type: 'selectwidget', title: 'SITE_GROUP', value: $stateParams.siteGroupName, options: vm.siteGroupSelect },
            serviceProviderGroupName: { type: 'selectwidget', title: 'SERVICE_PROVIDER_GROUP', value: $stateParams.serviceProviderGroupName, options: vm.serviceProviderGroupSelect },
            serviceProviderStatus: {
                type: 'options',
                title: 'SERVICE_PROVIDER_STATUS',
                value: $stateParams.serviceProviderStatus || 'all',
                options: statusOptions,
                clearValue: 'all'
            },
            dateRange: {
                type: 'date-range',
                title: 'BETWEEN_DATES',
                endMaxDate: moment().add(-1, 'days').format('MM-DD-YYYY, 23:59:59'),
                value: {
                    startDate: ($stateParams.dateRange !== null) ? moment(new Date($stateParams.dateRange.split(',')[0])) : null,
                    endDate: ($stateParams.dateRange !== null) ? moment(new Date($stateParams.dateRange.split(',')[1])) : null
                },
                clearValue: {
                    startDate: null,
                    endDate: null
                }
            }
        };

        vm.criteria.serviceProviderStatus.isClear =
            vm.criteria.serviceProviderStatus.value === vm.criteria.serviceProviderStatus.clearValue;

        if (coreClientsCollectionResponse.coreclients) {
            vm.criteria.coreClient = {
                type: 'jsonselectwidget',
                title: 'CORE_CLIENT',
                value: JSON.parse($stateParams.coreClient),
                options: {
                    response: coreClientsCollectionResponse,
                    link : coreClientsCollectionResponse && coreClientsCollectionResponse.count > 0 ? coreClientsCollectionResponse.getLink('self') : null,
                    responseKeyPath: 'coreclients',
                    itemValuePath: 'id',
                    itemTitlePath: 'name'
                }
            };
        }

        if (vm.criteria.site.value !== null) {
            vm.criteria.location.options.disabled = false;
        } else {
            vm.criteria.location.value = null;
        }

        function saveParams (selectModel) {
            if (selectModel.mapValue) {
                if (selectModel.selected === undefined) {
                    params[selectModel.mapValue] = null;
                } else {
                    $stateParams[selectModel.mapValue] = selectModel.selected.object.id
                }
            }

            vm.search();
        }

        function search(params) {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        }

        function updateShowPercentages() {
            vm.exportParams = {showPercentages: !!vm.showPercentages};
            showPercentagesService.saveShowPercentageState(!!vm.showPercentages);
        }

        function orderAction (key) {
            $stateParams.order = key;
            $state.go('.', angular.extend({}, $stateParams), { reload: $state.current });
        }

        function getTotalForReportType(reportType) {
            return vm.individualTotals[reportType] || {};
        }

        function isLoadingReportType(reportType) {
            return vm.individualLoadingStates[reportType] === true;
        }

        function loadServiceProviders() {
            vm.serviceProvidersLoading = true;

            var params = angular.copy($stateParams);
            if (params.serviceProviderStatus && params.serviceProviderStatus !== 'all') {
                params.status = params.serviceProviderStatus;
            }
            delete params.serviceProviderStatus;

            if (params.site) {
                params.site = JSON.parse(params.site).v;
            }

            if (params.location) {
                params.location = JSON.parse(params.location).v;
            }

            if (params.coreClient) {
                params.coreClient = JSON.parse(params.coreClient).v;
            }

            apiClient.get('/reports/sp-summary', params).then(function(response) {
                vm.serviceProvidersResponse = response;
                vm.serviceProviders = response.serviceProviders || [];
                vm.serviceProvidersLoading = false;

                // Load individual totals if we have service providers and cache is invalid
                if (vm.serviceProvidersResponse.count > 0) {
                    const isCacheValid = reportTotalsService.isCachedIndividualDataValid(params);
                    if (!isCacheValid) {
                        loadIndividualTotals(params);
                    } else {
                        // Use cached data
                        const cachedData = reportTotalsService.getCachedIndividualTotals();
                        vm.individualTotals = cachedData.totals;
                        vm.individualLoadingStates = cachedData.loadingStates;
                    }
                }
            }).catch(function(error) {
                console.error('Error loading service providers:', error);
                vm.serviceProvidersLoading = false;
                vm.serviceProvidersResponse = { count: 0 };
                vm.serviceProviders = [];
            });
        }

        function loadIndividualTotals(params) {
            const individualData = reportTotalsService.getIndividualTotalsData(params);

            // Set initial loading states
            vm.individualLoadingStates = individualData.loadingStates;
            vm.individualTotals = individualData.totals;

            // Handle each promise individually
            Object.keys(individualData.promises).forEach(function(reportType) {
                individualData.promises[reportType].then(function(response) {
                    if (response) {
                        // Merge the response data into individualTotals
                        vm.individualTotals[reportType] = response;
                    }
                    vm.individualLoadingStates[reportType] = false;
                }).catch(function(error) {
                    console.error('Error loading ' + reportType + ':', error);
                    vm.individualLoadingStates[reportType] = false;
                });
            });
        }

    }
})();
